import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_trust-risk-scanner/artifacts/hba274xy_54B4EC9E-BB10-4795-9462-EE34138F48D0.png';

const Footer = () => {
  return (
    <footer className="no-print bg-[#0B0B0D] border-t border-white/5 mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img src={LOGO_URL} alt="Subsurface" className="h-8 mb-4" />
            <p className="text-sm text-[#A0A0A0] leading-relaxed max-w-md">
              Identify trust gaps before they cost you revenue. Subsurface surfaces hidden friction across product, payments, and user experience.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">Platform</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/scan" className="text-sm text-[#A0A0A0] hover:text-[#FF6A00] transition-colors">
                  Run Scan
                </Link>
              </li>
              <li>
                <Link to="/gateway" className="text-sm text-[#A0A0A0] hover:text-[#FF6A00] transition-colors">
                  Talk to Gateway
                </Link>
              </li>
              <li>
                <Link to="/submit" className="text-sm text-[#A0A0A0] hover:text-[#FF6A00] transition-colors">
                  Submit Details
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-[#A0A0A0] hover:text-[#FF6A00] transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-[#A0A0A0] hover:text-[#FF6A00] transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/subsurface-qa-risk/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[#A0A0A0] hover:text-[#FF6A00] transition-colors flex items-center gap-1"
                >
                  <Linkedin className="w-3 h-3" />
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#A0A0A0]">
            © 2026 Subsurface. Trust & Risk Intelligence Platform.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-xs text-[#A0A0A0] hover:text-[#FF6A00] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-xs text-[#A0A0A0] hover:text-[#FF6A00] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
